export const placeholderUrl = 'https://stablecog.com';
